export const FailureMessage = (props: { message: string; color?: string }) => {
  return (
    <h1 style={{ color: props.color ? props.color : 'black' }}>
      {props.message}
    </h1>
  );
};
